module.exports = __webpack_public_path__ + "static/media/country_ic.792b8455.webp";